import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ChargeAttachType } from 'modules/equipment/types';
import { ListingForm } from 'components/shared/TableListing/types';

import type { ChargeListingService } from '../../../../../lib';
import { InvoiceDescriptionCell } from './InvoiceDescriptionCell';
import { EquipmentDescriptionCell } from './EquipmentDescriptionCell';
import { QuoteChargeListingEntity, QuoteLineItemType } from '../../../../../types';

interface Props {
  rowIndex: number;
  invoiceId: string;
  chargeService: ChargeListingService;
  onRemoveRow: VoidFunction;
  onEditEquipment: (id: string, rowIndex: number) => void;
  onRemoveEquipment: (id: string, rowIndex: number) => void;
}

export const DescriptionCell = ({
  rowIndex,
  invoiceId,
  chargeService,
  onRemoveRow,
  onEditEquipment,
  onRemoveEquipment,
}: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const rows = useWatch({ control, name: `bodyFields` });

  const currentRow = rows[rowIndex];
  const { type, charge, equipment } = currentRow;

  if (type === QuoteLineItemType.Equipment) {
    return (
      <EquipmentDescriptionCell
        equipment={equipment}
        onEditEquipment={id => onEditEquipment(id, rowIndex)}
        onRemoveEquipment={id => onRemoveEquipment(id, rowIndex)}
      />
    );
  }

  // Malformed row → fall back to the invoice bucket so the cell still renders;
  // parent options will simply be empty in that case.
  const scope = chargeService.resolveParentScope(currentRow, invoiceId) ?? {
    id: invoiceId,
    type: ChargeAttachType.Invoice,
  };

  return (
    <InvoiceDescriptionCell
      scope={scope}
      charge={charge!}
      rowIndex={rowIndex}
      onRemoveRow={onRemoveRow}
      chargeService={chargeService}
    />
  );
};
